// @ts-strict

import { Component, ElementRef, EventEmitter, Input, OnChanges, OnInit, Output, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { ICampaignConfigFieldData } from '@app/core/models/core-models';
import { LocalStorageService } from '@services/local-storage/local-storage.service';
import { isArray } from 'lodash';

export interface SelectValue {
  system?: string;
  value: number;
}

interface SelectItem {
  value: number | string;
  id: string;
}

@Component({
  selector: 'app-select-input',
  templateUrl: './select-input.component.html',
  styleUrls: ['./select-input.component.scss']
})
export class SelectInputComponent implements OnInit, OnChanges {
  @Input() selectedField?: string;
  @Input() fieldInfo?: ICampaignConfigFieldData;
  @Input() configurationData?: ICampaignConfigFieldData[];
  @Input() defaultValue?: number;
  @Input() submitted = false;
  @Output() emitValue: EventEmitter<SelectValue> = new EventEmitter();
  @ViewChild('selectFormContainer', { read: ElementRef }) selectFormContainer?: ElementRef<HTMLDivElement>;
  panelLanguage = '';
  selectForm: UntypedFormGroup = this.fb.group({
    select: [null, Validators.required]
  });

  public values: SelectItem[] = [];
  public isSelectMenuOpen = false;

  constructor(private localStorageService: LocalStorageService, private fb: UntypedFormBuilder) {}

  ngOnInit(): void {
    if (isArray(this.fieldInfo?.values)) {
      (this.fieldInfo!.values as Record<number, string>[]).map(value => {
        if (this.fieldInfo!.translations && !isArray(value)) {
          const [key, val] = Object.entries(value);

          if (val) {
            this.values.push({ id: key.toString(), value: val.toString() });

            return;
          }

          this.values.push({ id: key[0], value: key[1].toString() });
        }
      });
    }
    this.panelLanguage = this.localStorageService.getPanelLang();
    this.localStorageService.panelLanguage.subscribe(panelLang => {
      if (panelLang) {
        this.panelLanguage = panelLang;
      }
    });

    this.selectDefaultOption();
  }

  ngOnChanges(): void {
    if (this.defaultValue) {
      this.selectForm.get('select')?.patchValue(this.defaultValue);
      this.getValue();
    }
  }

  get configForm() {
    return this.selectForm?.controls;
  }

  selectDefaultOption(): void {
    if (this.configurationData) {
      const currentConfig = this.configurationData.find(value => value.system_name === this.fieldInfo?.system_name);
      if (currentConfig) {
        this.selectForm.get('select')?.patchValue(currentConfig.config_values ? currentConfig.config_values : this.values[0].id);
      }
      this.getValue();
    } else if (this.fieldInfo?.translations) {
      this.selectForm.get('select')?.patchValue(this.values[0].id);
      this.getValue();
    }
  }

  changeChevron(mode: string): void {
    this.isSelectMenuOpen = !this.isSelectMenuOpen;

    const chevron = this.selectFormContainer?.nativeElement.querySelector('.ng-arrow-wrapper');
    if (mode === 'open') {
      chevron?.classList.add('ng-select-open');
    } else {
      chevron?.classList.remove('ng-select-open');
    }
  }

  getValue(ev?: { id: string; value: string }): void {
    if (ev) this.handleOpen();

    const value: SelectValue = {
      system: this.fieldInfo?.system_name || '',
      value: this.configForm.select.value
    };

    this.emitValue.emit(value);
  }

  public handleOpen(): void {
    !this.isSelectMenuOpen ? this.changeChevron('open') : this.changeChevron('close');
  }
}
